<template>
    <ul class="autocomplete-cars" v-if="vehicles.length" ref="resultsBox">
        <li :class="{'active': i == key}" @mouseover="i = key" ref="results" @click="setObject()" v-for="(v, key) in vehicles" :key="key">{{v._plateNo}}</li>
    </ul>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Autocomplete',
    props: {
        search: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'erv'
        }
    },
    data() {
        return {
            i: 0,
            dontSearch: false,
            searchTimeoutInterval: null
        }
    },
    watch: {
        search: function(nVal, oVal) {
            if(!this.dontSearch) {
                if(this.searchTimeoutInterval) {
                    clearTimeout(this.searchTimeoutInterval);
                }

                this.searchTimeoutInterval = setTimeout(() => {
                    this.i = 0;
                    this.searchVehicles({
                        search: nVal,
                        type: this.type
                    });
                }, 300);
            }
            else {
                this.dontSearch = false;
            }
        },
    },
    computed: {
        ...mapGetters({
            vehicles: 'vehicles/getSearchVehicles'
        })
    },
    mounted() {
        this.addEventListeners();
    },
    beforeDestroy() {
        this.removeEventListeners();
    },
    methods: {
        ...mapActions({
            searchVehicles: 'vehicles/getSearchVehicles',
            clearSearchVehicles: 'vehicles/clearSearchVehicles'
        }),

        addEventListeners() {
            window.addEventListener('keydown', this.keydownHandle);
        },

        removeEventListeners() {
            window.removeEventListener('keydown', this.keydownHandle);
        },

        keydownHandle(e) {
            let keyCode = e.which;

            if(keyCode == 38) {
                this.i = this.i == 0 ? this.vehicles.length - 1 : this.i - 1;
                this.scrollInViewport(this.i);
            }
            else if(keyCode == 40) {
                this.i = this.i == this.vehicles.length - 1 ?  0 : this.i + 1;
                this.scrollInViewport(this.i);
            }
            else if(keyCode == 13) {
                this.setObject();
            }
        },

        setObject() {
            this.dontSearch = true;
            if(this.vehicles.length) {
                this.$emit('destroy');
                this.$emit('choose', this.vehicles[this.i]);
                this.clearSearchVehicles();
            }
        },

        scrollInViewport(index) {
            this.ensureInView(this.$refs.resultsBox, this.$refs.results[index]);
        },

        ensureInView(container, element) {
            //Determine container top and bottom
            let cTop = container.scrollTop;
            let cBottom = cTop + container.clientHeight;

            //Determine element top and bottom
            let eTop = element.offsetTop;
            let eBottom = eTop + element.clientHeight;

            //Check if out of view
            if (cBottom < eBottom) {
                container.scrollTop += (eBottom - cBottom);
            }
            else if (cTop > eTop) {
                container.scrollTop -= (cTop - eTop);
            }
        },
    },
}

</script>

<style lang="scss" scoped>
    .autocomplete-cars {
        width: 100%;
        border: 1px solid #C7C7C6;
        margin-top: 5px;
        border-radius: 4px;
        position: absolute;
        background: white;
        z-index: 10;
        max-height: 150px;
        overflow-x: hidden;
        overflow-y: auto;

        li {
            padding: 6px 10px;

            &.active {
                background: #0F2443;
                color: white;
            }

            &:hover {
                background: #0F2443;
                color: white;
                cursor: pointer;
            }
        }
    }
</style>
